import React, { useContext, useState } from "react";
import { styled, alpha, keyframes } from "@mui/material/styles"; // 1. Добавлен keyframes
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Slide, Menu, Typography, useMediaQuery, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { LangContext } from "../../LanguageProvider"; // 2. Исправлен путь
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useAuthStore from "../../services/AuthStore"; // 3. Исправлен путь
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import { useThemeToggle } from "../../services/ThemeContext"; // 4. Исправлен путь
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome"; // 5. Иконка для AI

// Стилизация верхней панели
const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px 16px",
  backdropFilter: "blur(24px)",
  boxShadow: theme.shadows[2],
}));

// Стилизация кнопок меню
const MenuButton = styled(Button)(({ theme }) => ({
  textTransform: "capitalize",
  margin: "0 8px",
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    color: theme.palette.primary.main,
    transition: "background-color 0.3s ease",
  },
}));

// --- 6. НОВАЯ АНИМИРОВАННАЯ КНОПКА ---
// Анимация "сияния"
const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 5px 0px ${alpha("#00AEEF", 0.7)};
  }
  50% {
    box-shadow: 0 0 20px 8px ${alpha("#00AEEF", 0.1)};
  }
  100% {
    box-shadow: 0 0 5px 0px ${alpha("#00AEEF", 0.7)};
  }
`;

// Стилизованная кнопка
const AiChatButton = styled(Button)(({ theme }) => ({
  textTransform: "capitalize",
  margin: "0 8px",
  color: theme.palette.common.white,
  // Градиент в стиле "AI"
  background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.light} 90%)`,
  boxShadow: `0 0 10px ${alpha(theme.palette.primary.light, 0.5)}`,
  borderRadius: theme.shape.borderRadius * 2,
  // Применяем анимацию
  animation: `${pulseAnimation} 2s infinite ease-out`,
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: `0 0 15px ${alpha(theme.palette.primary.light, 0.8)}`,
    background: `linear-gradient(45deg, ${theme.palette.primary.dark} 30%, ${theme.palette.secondary.main} 90%)`,
  },
  "& .MuiButton-startIcon": {
    marginRight: "4px",
  },
}));
// --- КОНЕЦ СТИЛЕЙ НОВОЙ КНОПКИ ---

const FlagIcon = ({ lang }) => (
  <img
    src={lang === "ru" ? "/photo/ru flag.webp" : "/photo/kaz flag.jpg"}
    alt={lang === "ru" ? "Russian Flag" : "Kazakh Flag"}
    style={{ width: 20, height: 20, marginRight: 8 }}
  />
);

export default function Header() {
  const [open, setOpen] = React.useState(false);
  const { lang, translations, changeLang } = useContext(LangContext);
  const { user, isAuthenticated, logout } = useAuthStore();
  const [searchTerm, setSearchTerm] = React.useState("");
  const [anchorElCollege, setAnchorElCollege] = React.useState(null);
  const [anchorElServices, setAnchorElServices] = React.useState(null);
  const [isSearchOpen, setIsSearchOpen] = React.useState(false);
  const navigate = useNavigate();
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const { toggleTheme } = useThemeToggle();

  const handleProfile = () => {
    // ... (существующий код handleProfile)
    if (user.roles.length > 0) {
      if (user.roles[0].id === 3) {
        navigate("/teacher");
      } else if (user.roles[0].id === 4) {
        navigate("/student");
      } else if (user.roles[0].id === 1) {
        navigate("/admin");
      } else if (user.roles[0].id === 2) {
        navigate("/moder");
      }
    }
  };

  const handleLogout = () => {
    // ... (существующий код handleLogout)
    logout();
    setUserMenuAnchor(null);
    navigate("/");
  };

  const toggleDrawer = newOpen => () => {
    // ... (существующий код toggleDrawer)
    setOpen(newOpen);
  };

  const handleSearchChange = event => {
    // ... (существующий код handleSearchChange)
    setSearchTerm(event.target.value);
  };

  const handleOpenCollegeMenu = event => {
    // ... (существующий код handleOpenCollegeMenu)
    setAnchorElCollege(event.currentTarget);
  };

  const handleCloseCollegeMenu = () => {
    // ... (существующий код handleCloseCollegeMenu)
    setAnchorElCollege(null);
  };

  const handleOpenServicesMenu = event => {
    // ... (существующий код handleOpenServicesMenu)
    setAnchorElServices(event.currentTarget);
  };

  const handleCloseServicesMenu = () => {
    // ... (существующий код handleCloseServicesMenu)
    setAnchorElServices(null);
  };

  const toggleSearchField = () => {
    // ... (существующий код toggleSearchField)
    setIsSearchOpen(prev => !prev);
    if (isSearchOpen) {
      setSearchTerm("");
    }
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        boxShadow: 0,
        bgcolor: "transparent",
        backgroundImage: "none",
        mt: 0.28,
        justifyContent: "center",
        textAlign: "center",
      }}>
      <Container maxWidth="lg" sx={{ px: 0 }}>
        <StyledToolbar variant="dense" disableGutters>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              {/* Кнопка "О колледже" с выпадающим меню */}
              <IconButton
                aria-label="Home button"
                onClick={() => {
                  navigate("/");
                }}>
                <img src="login.png" width="50px" height="50px" alt="Logo" />
              </IconButton>
              <MenuButton onClick={handleOpenCollegeMenu}>
                {translations["collegeinfo"]}
              </MenuButton>

              <Menu
                anchorEl={anchorElCollege}
                open={Boolean(anchorElCollege)}
                // ... (существующий код Menu "О колледже")
                onClose={handleCloseCollegeMenu}
                MenuListProps={{
                  onMouseLeave: handleCloseCollegeMenu,
                }}
                PaperProps={{
                  elevation: 3,
                  sx: {
                    minWidth: 180,
                  },
                }}>
                {[
                  {
                    label: translations["administration"],
                    route: "/administration",
                  },
                  {
                    label: translations["struct_college"],
                    route: "/structure",
                  },
                  {
                    label: translations["ourachevements"],
                    route: "/ourachevements",
                  },
                  { label: translations["plan"], route: "/plan" },
                  { label: translations["pck"], route: "/pck" },
                  { label: translations["emcourse"], route: "/emcourse" },
                  {
                    label: translations["atistation"],
                    route: "/atistation",
                  },
                  {
                    label: translations["otchet20242025"],
                    route: "/otchet20242025",
                  },
                  {
                    label: translations["sanitar"],
                    route: "/sanitar",
                  },
                ].map((item, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => {
                      navigate(item.route);
                      handleCloseCollegeMenu();
                    }}>
                    {item.label}
                  </MenuItem>
                ))}
              </Menu>

              {/* Кнопка "Услуги" с выпадающим меню */}
              <MenuButton onClick={handleOpenServicesMenu}>
                {translations["services"]}
              </MenuButton>

              <Menu
                anchorEl={anchorElServices}
                open={Boolean(anchorElServices)}
                // ... (существующий код Menu "Услуги")
                onClose={handleCloseServicesMenu}
                MenuListProps={{
                  onMouseLeave: handleCloseServicesMenu,
                }}
                PaperProps={{
                  elevation: 3,
                  sx: {
                    minWidth: 180,
                  },
                }}>
                {[
                  { label: translations["courses"], route: "/courses" },
                  {
                    label: translations["abiturient"],
                    route: "/abiturient",
                  },
                  {
                    label: translations["anticoruption"],
                    route: "/anticoruption",
                  },
                  { label: translations["Gagarin"], route: "/Gagarin" },
                ].map((item, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => {
                      navigate(item.route);
                      handleCloseServicesMenu();
                    }}>
                    {item.label}
                  </MenuItem>
                ))}
              </Menu>
              {/* Кнопка новости */}
              <MenuButton onClick={() => navigate("/news")}>
                {translations["news"]}
              </MenuButton>

              {/* --- 7. НОВАЯ КНОПКА AI CHAT (DESKTOP) --- */}
              <AiChatButton
                variant="contained"
                size="small" // Чтобы соответствовать другим кнопкам
                startIcon={<AutoAwesomeIcon sx={{ fontSize: 18 }} />}
                onClick={() => navigate("/ai-chat")} // Убедитесь, что роут /ai-chat настроен
              >
                AI-Zere Chat
              </AiChatButton>
              {/* --- КОНЕЦ НОВОЙ КНОПКИ --- */}
            </Box>
            <Box
              sx={{
                display: {
                  // ... (существующий код правой части хедера: Поиск, Профиль, Язык, Тема)
                  xs: "none",
                  md: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: 2, // Немного уменьшил gap
                },
              }}>
              {/* Строка поиска */}
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {!isSearchOpen ? (
                  <IconButton onClick={toggleSearchField}>
                    <SearchIcon />
                  </IconButton>
                ) : (
                  <TextField
                    variant="outlined"
                    size="small"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    placeholder={lang === "ru" ? "Поиск..." : "Іздеу..."}
                    sx={{
                      width: "200px",
                      borderRadius: "8px",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#191970",
                        },
                        "&:hover fieldset": {
                          borderColor: "#4169E1",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#191970",
                        },
                      },
                    }}
                    onBlur={toggleSearchField} // Закрытие при потере фокуса
                  />
                )}
              </Box>

              {/* Профиль пользователя */}
              {isAuthenticated ? (
                <>
                  <Button
                    onClick={e => setUserMenuAnchor(e.currentTarget)}
                    startIcon={<AccountCircleIcon />}
                    sx={{ textTransform: "none" }}>
                    {user?.username || "Профиль"}
                  </Button>
                  <Menu
                    anchorEl={userMenuAnchor}
                    open={Boolean(userMenuAnchor)}
                    onClose={() => setUserMenuAnchor(null)}>
                    <MenuItem onClick={handleProfile}>
                      <AccountCircleIcon />
                      {translations["profile"]}
                    </MenuItem>
                    <MenuItem onClick={handleLogout}>
                      <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                      {translations["logout"]}
                    </MenuItem>
                  </Menu>
                </>
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={() => navigate("/login")}>
                  {translations["login_btn_text"]}
                </Button>
              )}

              {/* Переключатель языка с флагом */}
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  changeLang(lang === "kz" ? "ru" : "kz");
                }}
                sx={{
                  padding: "5px 9px",
                }}
                startIcon={<FlagIcon lang={lang} />}
                color="primary">
                {lang}
              </Button>

              <Tooltip title="Версия для слабовидящих">
                <IconButton
                  onClick={toggleTheme}
                  size="small"
                  color="inherit"
                  sx={{
                    border: "1px solid",
                    borderColor: "text.primary",
                    borderRadius: "8px",
                  }}>
                  👁️
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          {/* Мобильное меню */}
          <Box
            sx={{
              // ... (существующий код мобильного меню)
              display: { xs: "flex", md: "none" },
              width: "100%",
              justifyContent: "space-between",
            }}>
            <IconButton
              aria-label="Home button"
              onClick={() => {
                navigate("/");
              }}>
              <img src="login.png" width="50px" height="50px" alt="Logo" />
            </IconButton>

            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>

            <Drawer
              anchor="top"
              open={open}
              onClose={toggleDrawer(false)}
              TransitionComponent={Slide}
              transitionDuration={500}>
              <Box
                sx={{
                  p: 2,
                  backgroundColor: "background.default",
                  minHeight: "100vh",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}>
                {/* Верхний контент */}
                <Box>
                  {/* Логотип и кнопка закрытия */}
                  <Box
                    sx={{
                      // ... (существующий код)
                      position: "absolute",
                      top: "8px",
                      left: "16px",
                      zIndex: 2,
                      display: "flex",
                      alignItems: "center",
                    }}>
                    <IconButton
                      aria-label="Home button"
                      onClick={() => {
                        navigate("/");
                        setOpen(false);
                      }}>
                      <img
                        src="login.png"
                        width="50px"
                        height="50px"
                        alt="Logo"
                      />
                    </IconButton>
                    <Typography variant="body2" sx={{ marginTop: 1 }}>
                      RVTK
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <IconButton
                      onClick={toggleDrawer(false)}
                      aria-label="Close menu">
                      <CloseRoundedIcon />
                    </IconButton>
                  </Box>
                  <Divider sx={{ my: 3 }} />

                  <Box
                    sx={{
                      // ... (существующий код)
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "12px",
                    }}>
                    <TextField
                      variant="outlined"
                      size="small"
                      // ... (существующий код)
                      value={searchTerm}
                      onChange={handleSearchChange}
                      placeholder={lang === "ru" ? "Поиск..." : "Іздеу..."}
                      sx={{
                        width: "500px",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#C0C0C0",
                          },
                          "&:hover fieldset": {
                            borderColor: "#4169E1",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#191970",
                          },
                        },
                      }}
                      onBlur={toggleSearchField} // Закрытие при потере фокуса
                    />
                  </Box>

                  {/* "О колледже" */}
                  <Accordion>
                    <AccordionSummary
                      // ... (существующий код)
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="college-menu-content"
                      id="college-menu-header">
                      <MenuButton sx={{ marginLeft: -1 }}>
                        {translations["collegeinfo"]}
                      </MenuButton>
                    </AccordionSummary>
                    <AccordionDetails>
                      {[
                        {
                          label: translations["administration"],
                          route: "/administration",
                        },
                        {
                          label: translations["struct_college"],
                          route: "/structure",
                        },
                        // ... (существующий код)
                        {
                          label: translations["ourachevements"],
                          route: "/ourachevements",
                        },
                        { label: translations["plan"], route: "/plan" },
                        { label: translations["pck"], route: "/pck" },
                        { label: translations["emcourse"], route: "/emcourse" },
                        {
                          label: translations["atistation"],
                          route: "/atistation",
                        },
                        {
                          label: translations["otchet20242025"],
                          route: "/otchet20242025",
                        },
                        {
                          label: translations["sanitar"],
                          route: "/sanitar",
                        },
                      ].map((item, index) => (
                        <MenuItem
                          key={index}
                          onClick={() => {
                            navigate(item.route);
                            setOpen(false);
                          }}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </AccordionDetails>
                  </Accordion>

                  {/* "Услуги" */}
                  <Accordion>
                    <AccordionSummary
                      // ... (существующий код)
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="services-menu-content"
                      id="services-menu-header">
                      <MenuButton sx={{ marginLeft: -1 }}>
                        {translations["services"]}
                      </MenuButton>
                    </AccordionSummary>
                    <AccordionDetails>
                      {[
                        { label: translations["courses"], route: "/courses" },
                        {
                          label: translations["abiturient"],
                          route: "/abiturient",
                        },
                        // ... (существующий код)
                        {
                          label: translations["anticoruption"],
                          route: "/anticoruption",
                        },
                        { label: translations["Gagarin"], route: "/Gagarin" },
                      ].map((item, index) => (
                        <MenuItem
                          key={index}
                          onClick={() => {
                            navigate(item.route);
                            setOpen(false);
                          }}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </AccordionDetails>
                  </Accordion>

                  {/* Новости */}
                  <MenuItem
                    sx={{
                      // ... (существующий код)
                      borderTop: "1px solid #d3d3d3",
                      borderBottom: "2px solid #d3d3d3",
                      borderRadius: "8px",
                      padding: "8px 16px",
                      margin: "8px 0",
                    }}
                    onClick={() => {
                      navigate("/news");
                      setOpen(false);
                    }}>
                    {translations["news"]}
                  </MenuItem>

                  {/* --- 8. НОВАЯ КНОПКА AI CHAT (MOBILE) --- */}
                  <MenuItem
                    sx={{
                      margin: "8px 0",
                      borderRadius: "8px",
                      // Используем похожий градиент
                      background: theme =>
                        `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.light} 90%)`,
                      color: "white",
                      "&:hover": {
                        background: theme =>
                          `linear-gradient(45deg, ${theme.palette.primary.dark} 30%, ${theme.palette.secondary.main} 90%)`,
                      },
                    }}
                    onClick={() => {
                      navigate("/ai-chat");
                      setOpen(false);
                    }}>
                    <AutoAwesomeIcon sx={{ mr: 1.5, fontSize: 20 }} />
                    <Typography variant="body1">AI-Zere Chat</Typography>
                  </MenuItem>
                  {/* --- КОНЕЦ НОВОЙ КНОПКИ --- */}
                </Box>

                {/* Кнопка "Вход" */}
                {isAuthenticated ? (
                  <>
                    <MenuItem
                      sx={{
                        // ... (существующий код)
                        borderTop: "1px solid #d3d3d3",
                        borderBottom: "2px solid #d3d3d3",
                        borderRadius: "8px",
                        padding: "8px 16px",
                        margin: "8px 0",
                      }}
                      onClick={handleProfile}>
                      <AccountCircleIcon />
                      {translations["profile"]}
                    </MenuItem>
                    <MenuItem
                      sx={{
                        // ... (существующий код)
                        borderTop: "1px solid #d3d3d3",
                        borderBottom: "2px solid #d3d3d3",
                        borderRadius: "8px",
                        padding: "8px 16px",
                        margin: "8px 0",
                      }}
                      onClick={handleLogout}>
                      <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                      {translations["logout"]}
                    </MenuItem>
                  </>
                ) : (
                  <MenuItem
                    sx={{
                      // ... (существующий код)
                      borderTop: "1px solid #d3d3d3",
                      borderBottom: "2px solid #d3d3d3",
                      borderRadius: "8px",
                      padding: "8px 16px",
                      margin: "8px 0",
                    }}
                    onClick={() => {
                      navigate("/login");
                      setOpen(false);
                    }}>
                    {translations["login_btn_text"]}
                  </MenuItem>
                )}

                {/* Переключатель языка */}
                <Box sx={{ marginTop: "auto" }}>
                  <MenuItem
                    sx={{
                      // ... (существующий код)
                      borderTop: "1px solid #d3d3d3",
                      borderRadius: "8px",
                      padding: "10px 20px",
                      display: "flex",
                      justifyContent: "center",
                      "&:hover": {
                        backgroundColor: alpha("#191970", 0.1),
                        transition: "background-color 0.3s ease",
                      },
                    }}
                    onClick={() => {
                      changeLang(lang === "kz" ? "ru" : "kz");
                    }}>
                    <FlagIcon lang={lang} />
                    <Typography variant="body2">
                      {lang === "ru"
                        ? "Сменить на казахский"
                        : "Сменить на русский"}
                    </Typography>
                  </MenuItem>

                  <MenuItem
                    sx={{
                      // ... (существующий код)
                      borderTop: "1px solid #d3d3d3",
                      borderRadius: "8px",
                      padding: "10px 20px",
                      display: "flex",
                      justifyContent: "center",
                      "&:hover": {
                        backgroundColor: alpha("#191970", 0.1),
                        transition: "background-color 0.3s ease",
                      },
                    }}
                    onClick={toggleTheme}>
                    <Typography variant="body2">
                      {lang === "ru"
                        ? "Версия для слабовидящих"
                        : "Көз көрмейтіндерге арналған нұсқа"}
                    </Typography>
                  </MenuItem>
                </Box>
              </Box>
            </Drawer>
          </Box>
        </StyledToolbar>
      </Container>
    </AppBar>
  );
}
